import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeFilter } from "../../features/filters/filterSlice";
import debounceHandler from "../../utils/debounceHandler";

function Search() {
    const dispatch = useDispatch();
    const { title } = useSelector((state) => state.filters) || {};

    const [search, setSearch] = useState(title);

    const doSearch = (value) => {
        dispatch(changeFilter(value));
    };

    const handleSearch = debounceHandler(doSearch, 500);

    return (
        <input
            className="flex items-center md:w-fit w-full mt-5 md:mt-0 px-4 md:ml-5 md:mr-2 text-sm bg-gray-200 rounded-full focus:outline-none focus:ring-1 focus:ring-green-300"
            type="search"
            placeholder="Search project name…"
            value={search}
            onChange={(e) => {
                setSearch(e.target.value);
                handleSearch(e.target.value);
            }}
        />
    );
}

export default Search;
